const Descriptions: Record<string, string> = {
  F1:
    "This node is infected with an unknown corrupted program. Destroy all the corrupted software to proceed.",
  C1:
    "This node is infected with an unknown corrupted program. Destroy all the corrupted software to proceed.",
  F3:
    "Pharmhaus offered this mission in exchange for a new piece of software. Deactivate all the malfunctioning security units.",
  C2: "This node contains the Level 2 access codes. Capture the code to access Level 2 nodes.",
  W1:
    "Leo's Shop - a quality shop of basic programs at low prices. Come and see what we've got to offer.",
  F2:
    "This node is infected with an unknown corrupted program. Destroy all the corrupted software to proceed.",
  L1:
    "S.M.A.R.T uses this node's security as a test mission. Defeat all the security software to proceed.",
  L2:
    "This node has reported a security bug that has locked down its internal network. Defeat the security software to proceed.",
  C4:
    "This node is reporting corrupted program problems similar to the Pharmhaus intrusions. Destroy the corrupted software.",
  L3:
    "This node contains the logs related to the Pharmhaus and Cellular Automata corrupted programs. Retrieve the logs to succeed in this mission.",
  F4:
    "Superphreak asked for the logs of this node to find a pattern in the corrupt program attacks. Collect the logs to succeed.",
  C3:
    "This node's security is hyperalert after a recent hack job. Disable it to proceed to the warez node.",
  W2: "Brought to you by new future technologies - software options for the here and beyond.",
  L4: "Deactivate the security at this node in order to proceed.",
  L5: "This node contains the Level 3 access codes. Capture the code to access Level 3 nodes.",
  L6: "Disarray said he took care of this node, but security seems unusally active...",
  W3: "A selection of the finer software on the net. For the discerning customer only.",
  P1:
    "Firewalls and heavy defenses are keeping all users out. Disable all the defenses to keep moving.",
  F5:
    "Firewalls and heavy defenses are keeping all users out. Disable all the defenses to keep moving.",
  F6: "This node contains the Level 4 access codes. Capture the code to access Level 4 nodes.",
  D1:
    "This is one of the malfunctioning nodes Wintermutant mentioned. Disable the security to repair the damage.",
  D2:
    "This is one of the malfunctioning nodes Wintermutant mentioned. Disable the security to repair the damage.",
  D3:
    "This node connects to the two nodes containing the program Disarray wanted. Disable security here to access these nodes.",
  D5:
    "Half of the program Disarray wants is here. Collect the keys to temporarily shut down the node's surveillance and allow Disarray access.",
  D4: "Disable the security software in this node to proceed.",
  P2:
    "This node is a backdoor entrance to the Cellular Automata S.A. Archives. Disable the security here to proceed.",
  P3:
    "There is a large reward to recover stolen files from a P.E.D. executive. Pick up the file sbefore security stops you.",
  L8:
    "Half of the program Disarray wants is here. Collect the keys to temporarily shut down the node's surveillance and allow Disarray access.",
  L7:
    "An enemy hacker has heightened the security in this node and locked out all users. Defeat these programs to proceed.",
  C5: "This node is the gateway to the Sysadmin archives. Disable the security here to proceed.",
  C6:
    "This node is currently locked down, and Cellular Automata needs a file from it. Retrieve the file to win a new piece of software.",
  W4:
    "The expert hacker's choice, this warez node deals exclusively in the rarest and most powerful software available.",
  D6:
    "The Nightfall hacker has heightened the security in this node and locked out all users. Defeat these programs to proceed.",
  L9:
    "Wintermutant found an experimental piece of software here. Retrieve the program before the corrupted programs left to protect it can disconnect you.",
  P4:
    "The Nightfall hacker has heightened the security in this node and locked out all users. Defeat these programs to proceed.",
  F7:
    "Deactivate the security system here and allow Joana to set up a link to Disarray's headquarters.",
  P5:
    "Disarray has filled this node with corrupt programs set to attack anyone who logs in. Destroy these corrupted programs to proceed.",
  P6:
    "Disarray has filled this node with corrupt programs set to attack anyone who logs in. Destroy these corrupted programs to proceed.",
  P7:
    "P.E.D. has offered a large credit reward to the agent who can destroy a malfunctioning memory cell. Eliminate the corrupted programs to succeed.",
  F8: "This node contains the Level 5 access codes. Capture the code to access Level 5 nodes.",
  Q1:
    "Disarray's Headquarters. Defeat all of his security to disable the Nightfall software and prevent midnight.",
  S1: "Center for Information about S.M.A.R.T. and its operations",
};

export default Descriptions;
